import { render, staticRenderFns } from "./ImageFeed.vue?vue&type=template&id=674f1301&"
import script from "./ImageFeed.vue?vue&type=script&lang=js&"
export * from "./ImageFeed.vue?vue&type=script&lang=js&"
import style0 from "./ImageFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports